module.exports = __webpack_public_path__ + "static/media/wherheim.9468b750.png";